import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
let RoiDataItem = class RoiDataItem extends Vue {
    polygons;
    roiType;
    activeTask;
    complete;
    roiDisabled;
    uncheckedImg = require('@blade-sxp/task-management/assets/subtract.png');
    selectImg = require('@blade-sxp/task-management/assets/select.png');
    roi = require('@blade-sxp/task-management/assets/roi.png'); // roi 多边形
    line = require('@blade-sxp/task-management/assets/line.png'); // line
    bodyFrame = require('@blade-sxp/task-management/assets/bodyframe.png'); // Bodyframe
    tipInfor = {
        tipImg: '',
        tipType: '',
    };
    placeholder;
    get isShowRoiMap() {
        return this.polygons && this.polygons.length;
    }
    getRoiType(val) {
        switch (val) {
            case 'line':
                this.tipInfor.tipImg = this.line;
                this.tipInfor.tipType = 'line';
                break;
            case 'bodyFrame':
                this.tipInfor.tipImg = this.bodyFrame;
                this.tipInfor.tipType = 'BodyFrame';
                break;
            default:
                this.tipInfor.tipImg = this.roi;
                this.tipInfor.tipType = 'ROI';
        }
    }
    startDraw() {
        this.$emit('start-draw', true);
    }
    getI18n(tip) {
        return this.$i18n.t(tip);
    }
    showRoiMap() {
        this.$emit('show-roi-map', true);
    }
    setRoiBadyMap() {
        console.log(12222222222222);
        this.$emit('set-roi-badyMap', true);
    }
};
__decorate([
    Prop({})
], RoiDataItem.prototype, "polygons", void 0);
__decorate([
    Prop({ default: 'roiArea', type: String })
], RoiDataItem.prototype, "roiType", void 0);
__decorate([
    Prop({ default: '', type: String })
], RoiDataItem.prototype, "activeTask", void 0);
__decorate([
    Prop({ default: false })
], RoiDataItem.prototype, "complete", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], RoiDataItem.prototype, "roiDisabled", void 0);
__decorate([
    Prop({ default: '' })
], RoiDataItem.prototype, "placeholder", void 0);
__decorate([
    Watch('roiType', { immediate: true })
], RoiDataItem.prototype, "getRoiType", null);
RoiDataItem = __decorate([
    Component({
        name: 'RoiDataItem',
        i18n: {
            messages: {
                en: {
                    roiArea: 'ROI Area',
                    roiTip: 'Are you sure to delete this ROI?',
                    tip: 'Tips',
                    confirm: 'confirm',
                    cancel: 'cancel',
                    examples: 'Examples',
                },
                zh: {
                    roiArea: 'ROI 区域',
                    roiTip: '确认删除该ROI吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    examples: '示例',
                },
            },
        },
    })
], RoiDataItem);
export default RoiDataItem;
